import mod from "-!./U3SearchResult.js?vue&type=script&lang=js&"; export default mod; export * from "-!./U3SearchResult.js?vue&type=script&lang=js&"